export default values => {
  const errors = {};

  if (!values.cargo || !values.cargo.length || values.cargo.length < 1) {
    errors.cargo = { _error: 'At least one cargo should be entered' };
  } else {
    const cargoArrayErrors = [];
    values.cargo.forEach((field, index) => {
      const fieldErrors = {};

      if (field.container ||
        // removing value from the container field and having a value and focus in one of the fields
        (field.length || field.width || field.height)) {
        if (!field.length) {
          fieldErrors.length = { _error: 'Required' };
        }
        if (!field.width) {
          fieldErrors.width = { _error: 'Required' };
        }
      }

      if (field?.description?.length > 255) {
        fieldErrors.description = { _error: 'Max 255 characters' };
      }

      if (!field?.devices?.length) {
        fieldErrors.devices = { _error: 'Required' };
      } else {
        const allDevicesValues = values.cargo.flatMap(c => c.devices?.map(d => d.id) ?? []);
        const duplicates = allDevicesValues.filter((d, i, self) => self.indexOf(d) !== i);
        const disabled = field.devices.filter(d => d.disabledBy);

        if (duplicates.length) {
          fieldErrors.devices = { _error: 'Each cargo item should have unique devices' };
        }

        if (disabled.length) {
          const ending = disabled.length > 1 ? 's' : '';
          const verb = disabled.length > 1 ? 'are' : 'is';
          const labels = disabled.map(d => d.label).join(', ');
          fieldErrors.devices = { _error: `Device${ending} ${labels} ${verb} in use` };
        }
      }

      cargoArrayErrors[index] = fieldErrors;
    });

    if (cargoArrayErrors.length) {
      errors.cargo = cargoArrayErrors;
    }
  }
  return errors;
};
